"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("./models");
exports.Severity = models_1.Severity;
var sdk_1 = require("./sdk");
exports._callOnClient = sdk_1._callOnClient;
exports.addBreadcrumb = sdk_1.addBreadcrumb;
exports.bindClient = sdk_1.bindClient;
exports.captureMessage = sdk_1.captureMessage;
exports.captureException = sdk_1.captureException;
exports.captureEvent = sdk_1.captureEvent;
exports.clearScope = sdk_1.clearScope;
exports.getCurrentClient = sdk_1.getCurrentClient;
exports.popScope = sdk_1.popScope;
exports.pushScope = sdk_1.pushScope;
exports.setUserContext = sdk_1.setUserContext;
exports.setTagsContext = sdk_1.setTagsContext;
exports.setExtraContext = sdk_1.setExtraContext;
exports.withScope = sdk_1.withScope;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../.semaphore-cache/solaris-frontend/node_modules/@sentry/shim/dist/index.js
// module id = 380
// module chunks = 19